import {storage} from './Storage';

export {storage};
